// extracted by mini-css-extract-plugin
export default {"scrollBlock":"TermsOfUse_scrollBlock__yA+Xb","modal":"TermsOfUse_modal__7wGv1","title":"TermsOfUse_title__3MsQn","block":"TermsOfUse_block__zExNJ","float":"TermsOfUse_float__fKHzj"};